/* eslint-disable max-len */
/* eslint-disable object-curly-newline */
/* eslint-disable no-console */
import React, { useState, MouseEvent } from "react";

import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogActions from "@mui/material/DialogActions";
import Grid from "@mui/material/Grid";
import Button from "@mui/material/Button";

import ErrorIcon from "@mui/icons-material/ErrorOutlineOutlined";

import { DialogState, setError, setErrorSetter } from "../../logic/hook/useDialogStateHelper";

import { StyledDialog } from "./Dialog";

export const ErrorDialog = () => {
    const [errorState, setErrorState] = useState<DialogState>({ open: false });
    setErrorSetter(setErrorState);
    setError(errorState);
    const resolve = () => {
        if (errorState.resolve) {
            errorState.resolve(false);
        }
    };

    const onClickOK = () => {
        resolve();
        setErrorState({ open: false });
    };
    const onClose = (event: MouseEvent<HTMLInputElement>, reason: "backdropClick") => {
        // バックドロップクリック時に閉じるのを無効化
        if (reason === "backdropClick") {
            return;
        }
        onClickOK();
    };

    return (
        <>
            {errorState.open && errorState.message && (
                <StyledDialog open={errorState.open} onClose={onClose} fullWidth>
                    <DialogTitle component="div">
                        <Grid container direction="row" justifyContent="flex-start" alignItems="center" sx={{ width: "100%" }}>
                            <ErrorIcon />
                            エラー
                        </Grid>
                    </DialogTitle>
                    <DialogContent dividers sx={{ maxHeight: "70vh" }}>
                        <DialogContentText
                            dangerouslySetInnerHTML={{
                                __html: errorState.message,
                            }}
                        />
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={onClickOK} size="small">
                            OK
                        </Button>
                    </DialogActions>
                </StyledDialog>
            )}
        </>
    );
};
